(function() {
  'use strict';

  var MONTHS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
  var DAYS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  var WEEKDAYS = ['Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa', 'Di'];
  var SETTINGS_PROMISE = null;

  function boutiqueClock(now) {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', {timeZone:'Europe/Paris',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23'}).formatToParts(now || new Date()).forEach(function(p){parts[p.type]=p.value;});
    return new Date(+parts.year, +parts.month-1, +parts.day, +parts.hour, +parts.minute);
  }
  function boutiqueWindow(date, blackouts, delay, now) {
    delay = Math.max(15, Number(delay) || 0);
    var clock = boutiqueClock(now), today = localMidnight(clock), tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate()+1);
    if (clock.getDay() < 2 || date < today || date > tomorrow || date.getDay() < 2 || blackouts[isoDate(date)]) return null;
    var start = date.getDay() === 6 ? 660 : 720;
    if (isoDate(date) === isoDate(today)) start = Math.max(start, clock.getHours()*60+clock.getMinutes()+delay);
    return start < 1080 ? [start,1080] : null;
  }
  function smallBatchMinimumDate(now) {
    var paris = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
    }).formatToParts(now || new Date()).forEach(function(part) { paris[part.type] = part.value; });
    var clock = new Date(Number(paris.year), Number(paris.month) - 1, Number(paris.day), Number(paris.hour), Number(paris.minute), Number(paris.second));
    var candidate = new Date(clock.getFullYear(), clock.getMonth(), clock.getDate());
    var offsets = {2: 4, 3: 2, 4: 1, 5: 1, 6: 2};
    for (var i = 0; i < 15; i++) {
      var weekday = candidate.getDay();
      if (offsets[weekday]) {
        var deadline = new Date(candidate.getFullYear(), candidate.getMonth(), candidate.getDate() - offsets[weekday], 18);
        if (clock < deadline) return candidate;
      }
      candidate.setDate(candidate.getDate() + 1);
    }
    return candidate;
  }

  function creamMinimumDate(now) {
    var paris = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
    }).formatToParts(now || new Date()).forEach(function(part) { paris[part.type] = part.value; });
    var clock = new Date(Number(paris.year), Number(paris.month) - 1, Number(paris.day), Number(paris.hour), Number(paris.minute), Number(paris.second));
    var candidate = new Date(clock.getFullYear(), clock.getMonth(), clock.getDate());
    var offsets = {2: 4, 3: 5, 4: 2, 5: 2, 6: 3};
    for (var i = 0; i < 15; i++) {
      var weekday = candidate.getDay();
      if (offsets[weekday]) {
        var deadline = new Date(candidate.getFullYear(), candidate.getMonth(), candidate.getDate() - offsets[weekday], 10);
        if (clock < deadline) return candidate;
      }
      candidate.setDate(candidate.getDate() + 1);
    }
    return candidate;
  }

  function bentoMinimumDate(now) {
    var paris = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit',
      day: '2-digit', hour: '2-digit', hourCycle: 'h23'
    }).formatToParts(now || new Date()).forEach(function(part) { paris[part.type] = part.value; });
    var today = new Date(Number(paris.year), Number(paris.month) - 1, Number(paris.day));
    var weekday = today.getDay();
    var mondayOffset = (weekday + 6) % 7;
    var firstDay = 9;
    if (weekday === 1) firstDay = Number(paris.hour) < 18 ? 2 : 3;
    if (weekday === 2) firstDay = Number(paris.hour) < 18 ? 3 : 4;
    if (weekday === 3 && Number(paris.hour) < 18) firstDay = 4;
    today.setDate(today.getDate() - mondayOffset + firstDay);
    return today;
  }

  function pad(value) { return value < 10 ? '0' + value : String(value); }

  function isoDate(date) {
    return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate());
  }

  function localMidnight(date) {
    var value = new Date(date.getTime());
    value.setHours(0, 0, 0, 0);
    return value;
  }

  function formatFrenchDate(date) {
    return DAYS[date.getDay()] + ' ' + date.getDate() + ' ' + MONTHS[date.getMonth()] + ' ' + date.getFullYear();
  }

  function firstOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth(), 1);
  }

  function sameMonth(a, b) {
    return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth();
  }

  function extractJsonObject(source, marker, searchFrom) {
    var markerAt = source.indexOf(marker, searchFrom || 0);
    if (markerAt === -1) return null;
    var start = source.indexOf('{', markerAt + marker.length);
    if (start === -1) return null;

    var depth = 0;
    var inString = false;
    var escaped = false;

    for (var i = start; i < source.length; i++) {
      var char = source.charAt(i);
      if (inString) {
        if (escaped) escaped = false;
        else if (char === '\\') escaped = true;
        else if (char === '"') inString = false;
        continue;
      }
      if (char === '"') { inString = true; continue; }
      if (char === '{') depth++;
      if (char === '}') {
        depth--;
        if (depth === 0) {
          try { return JSON.parse(source.slice(start, i + 1)); }
          catch (error) { return null; }
        }
      }
    }
    return null;
  }

  function findSettingsInDocument(doc) {
    var scripts = doc.querySelectorAll('script');
    for (var i = 0; i < scripts.length; i++) {
      var source = scripts[i].textContent || '';
      var searchFrom = 0;
      while (searchFrom < source.length) {
        var markerAt = source.indexOf('storePickupSettings', searchFrom);
        if (markerAt === -1) break;
        var settings = extractJsonObject(source, 'storePickupSettings', markerAt);
        if (settings && (
          Object.prototype.hasOwnProperty.call(settings, 'blackoutDates') ||
          Object.prototype.hasOwnProperty.call(settings, 'enableBlackoutDates') ||
          Object.prototype.hasOwnProperty.call(settings, 'min_days')
        )) return settings;
        searchFrom = markerAt + 'storePickupSettings'.length;
      }
    }
    return null;
  }

  function loadCrSettings() {
    if (SETTINGS_PROMISE) return SETTINGS_PROMISE;

    if (window.storePickupSettings && typeof window.storePickupSettings === 'object') {
      SETTINGS_PROMISE = Promise.resolve(window.storePickupSettings);
      return SETTINGS_PROMISE;
    }

    var current = findSettingsInDocument(document);
    if (current) {
      SETTINGS_PROMISE = Promise.resolve(current);
      return SETTINGS_PROMISE;
    }

    SETTINGS_PROMISE = fetch('/cart', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'text/html' },
      cache: 'no-store'
    }).then(function(response) {
      if (!response.ok) throw new Error('Le calendrier de retrait est indisponible.');
      return response.text();
    }).then(function(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var settings = findSettingsInDocument(doc);
      if (!settings) throw new Error('Les dates indisponibles n’ont pas pu être chargées.');
      return settings;
    }).catch(function(error) {
      SETTINGS_PROMISE = null;
      throw error;
    });

    return SETTINGS_PROMISE;
  }

  function blackoutMap(settings) {
    var result = {};
    if (!settings || settings.enableBlackoutDates === false) return result;

    String(settings.blackoutDates || '').split('-').forEach(function(entry) {
      var bits = entry.split(',');
      if (bits.length !== 3) return;
      var year = parseInt(bits[0], 10);
      var month = parseInt(bits[1], 10);
      var day = parseInt(bits[2], 10);
      if (isNaN(year) || isNaN(month) || isNaN(day)) return;
      result[year + '-' + pad(month + 1) + '-' + pad(day)] = true;
    });
    return result;
  }

  function ProductPickup(root) {
    this.root = root;
    this.form = root.closest('form');
    this.submit = this.form ? this.form.querySelector('[type="submit"]') : null;
    this.submitLabel = this.submit ? this.submit.textContent : '';
    this.repairTimer = null;
    this.boutiqueNoPickup = false;
    this.status = root.querySelector('[data-adg-pickup-status]');
    this.help = root.querySelector('.adg-product-pickup__help');
    this.calendar = root.querySelector('[data-adg-pickup-calendar]');
    this.monthLabel = root.querySelector('[data-adg-pickup-month]');
    this.daysRoot = root.querySelector('[data-adg-pickup-days]');
    this.prev = root.querySelector('[data-adg-pickup-prev]');
    this.next = root.querySelector('[data-adg-pickup-next]');
    this.time = root.querySelector('[data-adg-pickup-time]');
    this.dateProperty = root.querySelector('[data-adg-pickup-date-property]');
    this.isoProperty = root.querySelector('[data-adg-pickup-iso-property]');
    this.selection = root.querySelector('[data-adg-pickup-selection]');
    this.boutique = root.getAttribute('data-lead-days') === 'boutique';
    this.useSettingsLeadDays = root.getAttribute('data-lead-days') === 'settings';
    this.bentoWeekly = root.getAttribute('data-lead-days') === 'bento-weekly';
    this.creamWeekly = root.getAttribute('data-lead-days') === 'cream-weekly';
    this.smallBatchWeekly = root.getAttribute('data-lead-days') === 'small-batch-weekly';
    this.leadDays = this.useSettingsLeadDays
      ? 2
      : Math.max(0, parseInt(root.getAttribute('data-lead-days'), 10) || 0);
    this.maxMonths = Math.max(1, parseInt(root.getAttribute('data-max-months'), 10) || 12);
    this.blackouts = {};
    this.settingsReady = false;
    this.settingsFailed = false;
    this.selectedDate = null;
    this.selectedTime = '';
    this.currentMonth = firstOfMonth(new Date());
    this.updateHelp();
    this.bind();
    if (this.boutique && this.form) {
      var self = this;
      this.form.addEventListener('input',function(event){
        if (event.target.closest('[data-adg-product-pickup]')) return;
        if (self.selectedDate) { self.setTimeOptions(self.selectedDate); self.updateSelection(); }
      });
    }
    this.renderWeekdays();
    this.reset();
  }

  ProductPickup.prototype.updateHelp = function() {
    if (!this.help) return;
    if (this.boutique) {
      this.help.textContent = 'Retrait aujourd’hui ou demain, selon les disponibilités. Prévoyez au minimum 15 minutes de préparation pour toute commande.';
      return;
    }
    if (this.bentoWeekly || this.smallBatchWeekly || this.creamWeekly) {
      this.help.textContent = '';
      this.help.hidden = true;
      return;
    }
    this.help.textContent = 'Minimum ' + this.leadDays + ' jour' + (this.leadDays > 1 ? 's' : '') + ' ouvrés à l’avance. Après 18h, le délai commence le lendemain. Les dimanches, lundis et dates indisponibles sont bloqués.';
  };

  ProductPickup.prototype.refreshElements = function() {
    this.form = this.root.closest('form') || this.form;
    this.submit = this.form ? this.form.querySelector('[type="submit"]') : null;
    this.time = this.root.querySelector('[data-adg-pickup-time]');
    this.dateProperty = this.root.querySelector('[data-adg-pickup-date-property]');
    this.isoProperty = this.root.querySelector('[data-adg-pickup-iso-property]');
    this.pickupProperty = this.root.querySelector('input[name="properties[_Retrait par produit]"]');
  };

  ProductPickup.prototype.clearProperties = function() {
    this.refreshElements();
    if (this.dateProperty) {
      this.dateProperty.value = '';
      this.dateProperty.setAttribute('value', '');
    }
    if (this.isoProperty) {
      this.isoProperty.value = '';
      this.isoProperty.setAttribute('value', '');
    }
    if (this.pickupProperty) {
      this.pickupProperty.value = 'Oui';
      this.pickupProperty.setAttribute('value', 'Oui');
    }
  };

  ProductPickup.prototype.syncProperties = function() {
    this.refreshElements();
    if (!this.selectedDate || !this.time || !this.dateProperty || !this.isoProperty) return false;
    var timeValue = this.time.value || this.selectedTime;
    if (!timeValue) return false;
    this.time.value = timeValue;
    this.selectedTime = timeValue;
    var dateLabel = formatFrenchDate(this.selectedDate);
    var dateIso = isoDate(this.selectedDate);
    this.dateProperty.value = dateLabel;
    this.dateProperty.setAttribute('value', dateLabel);
    this.isoProperty.value = dateIso;
    this.isoProperty.setAttribute('value', dateIso);
    if (this.pickupProperty) {
      this.pickupProperty.value = 'Oui';
      this.pickupProperty.setAttribute('value', 'Oui');
    }
    return !!(this.dateProperty.value && this.isoProperty.value && this.time.value);
  };

  ProductPickup.prototype.bind = function() {
    var self = this;
    if (this.form) {
      var protectSubmission = function(event) {
        if (self.isValid(true)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      };
      this.form.addEventListener('submit', protectSubmission, true);
      this.form.addEventListener('formdata', function(event) {
        if (!self.selectedDate || !self.selectedTime) return;
        event.formData.set('properties[Date de retrait]', formatFrenchDate(self.selectedDate));
        event.formData.set('properties[_Date de retrait ISO]', isoDate(self.selectedDate));
        event.formData.set('properties[Créneau de retrait]', self.selectedTime);
        event.formData.set('properties[_Retrait par produit]', 'Oui');
      });
      window.addEventListener('submit', function(event) {
        if (event.target !== self.form) return;
        protectSubmission(event);
      }, true);
      window.addEventListener('click', function(event) {
        self.refreshElements();
        if (!self.submit || event.target !== self.submit && !self.submit.contains(event.target)) return;
        protectSubmission(event);
      }, true);
      this.form.addEventListener('input', function() {
        window.setTimeout(function() {
          if (self.selectedDate && self.time && self.time.value) {
            self.syncProperties();
            self.updateSelection();
          }
        }, 0);
      }, true);
      this.form.addEventListener('change', function() {
        window.setTimeout(function() {
          if (self.selectedDate && self.time && self.time.value) {
            self.syncProperties();
            self.updateSelection();
          }
        }, 0);
      }, true);
      if (window.MutationObserver) {
        this.formObserver = new MutationObserver(function() {
          self.refreshElements();
          if (self.selectedDate && self.time && self.time.value) self.syncProperties();
          self.updateSubmit();
        });
        this.formObserver.observe(this.form, { childList: true, subtree: true });
      }
      this.repairTimer = window.setInterval(function() {
        if (!document.documentElement.contains(self.root)) {
          window.clearInterval(self.repairTimer);
          return;
        }
        if (self.selectedDate && self.time && self.time.value) self.syncProperties();
      }, 400);
    }
    this.prev.addEventListener('click', function() {
      self.currentMonth = new Date(self.currentMonth.getFullYear(), self.currentMonth.getMonth() - 1, 1);
      self.render();
    });
    this.next.addEventListener('click', function() {
      self.currentMonth = new Date(self.currentMonth.getFullYear(), self.currentMonth.getMonth() + 1, 1);
      self.render();
    });
    this.time.addEventListener('change', function() {
      self.selectedTime = self.time.value;
      self.updateSelection();
    });
  };

  ProductPickup.prototype.renderWeekdays = function() {
    var target = this.root.querySelector('[data-adg-pickup-weekdays]');
    target.innerHTML = '';
    WEEKDAYS.forEach(function(label) {
      var span = document.createElement('span');
      span.className = 'adg-product-pickup__weekday';
      span.textContent = label;
      target.appendChild(span);
    });
  };

  ProductPickup.prototype.preparationDelay = function() {
    if (this.boutique) return 15;
    if (!this.form) return 0;
    return Array.from(this.form.querySelectorAll('input[type="text"],textarea')).some(function(input){
      return !input.disabled && input.value.trim() && (input.name || '').indexOf('properties[') === 0;
    }) ? 15 : 0;
  };
  ProductPickup.prototype.minimumDate = function() {
    if (this.boutique) return localMidnight(boutiqueClock());
    if (this.creamWeekly) return creamMinimumDate(new Date());
    if (this.smallBatchWeekly) return smallBatchMinimumDate(new Date());
    if (this.bentoWeekly) return bentoMinimumDate(new Date());
    var now = new Date();
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit',
      day: '2-digit', hour: '2-digit', hourCycle: 'h23'
    }).formatToParts(now);
    var paris = {};
    parts.forEach(function(part) { paris[part.type] = part.value; });
    var min = new Date(Number(paris.year), Number(paris.month) - 1, Number(paris.day));
    if (Number(paris.hour) >= 18) min.setDate(min.getDate() + 1);
    var remaining = this.leadDays;
    while (remaining > 0) {
      min.setDate(min.getDate() + 1);
      var day = min.getDay();
      if (day !== 0 && day !== 1 && !this.blackouts[isoDate(min)]) remaining--;
    }
    return min;
  };

  ProductPickup.prototype.maximumDate = function() {
    if (this.boutique) { var tomorrow = localMidnight(boutiqueClock()); tomorrow.setDate(tomorrow.getDate()+1); return tomorrow; }
    var max = this.minimumDate();
    max.setMonth(max.getMonth() + this.maxMonths);
    return max;
  };

  ProductPickup.prototype.isAvailable = function(date) {
    if (this.boutique) return !!boutiqueWindow(date, this.blackouts, this.preparationDelay());
    var day = date.getDay();
    if (day === 0 || day === 1) return false;
    if (date < this.minimumDate() || date > this.maximumDate()) return false;
    return !this.blackouts[isoDate(date)];
  };

  ProductPickup.prototype.firstAvailableDate = function() {
    var date = this.minimumDate();
    var maximum = this.maximumDate();
    while (date <= maximum) {
      if (this.isAvailable(date)) return localMidnight(date);
      date.setDate(date.getDate() + 1);
    }
    return null;
  };

  ProductPickup.prototype.publishFirstAvailableDate = function() {
    var date = this.firstAvailableDate();
    var detail = {
      iso: date ? isoDate(date) : '',
      label: date ? formatFrenchDate(date) : 'à confirmer'
    };
    this.root.setAttribute('data-first-available-date', detail.iso);
    this.root.setAttribute('data-first-available-label', detail.label);
    this.root.dispatchEvent(new CustomEvent('adg:pickup-first-available', {
      bubbles: true,
      detail: detail
    }));
  };

  ProductPickup.prototype.render = function() {
    var self = this;
    var minMonth = firstOfMonth(this.minimumDate());
    var maxMonth = firstOfMonth(this.maximumDate());

    if (this.currentMonth < minMonth) this.currentMonth = minMonth;
    if (this.currentMonth > maxMonth) this.currentMonth = maxMonth;

    this.monthLabel.textContent = MONTHS[this.currentMonth.getMonth()] + ' ' + this.currentMonth.getFullYear();
    this.prev.disabled = sameMonth(this.currentMonth, minMonth);
    this.next.disabled = sameMonth(this.currentMonth, maxMonth);
    this.daysRoot.innerHTML = '';

    var firstWeekdayMonday = (this.currentMonth.getDay() + 6) % 7;
    for (var blank = 0; blank < firstWeekdayMonday; blank++) {
      var spacer = document.createElement('span');
      spacer.className = 'adg-product-pickup__blank';
      spacer.setAttribute('aria-hidden', 'true');
      this.daysRoot.appendChild(spacer);
    }

    var daysInMonth = new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth() + 1, 0).getDate();
    for (var day = 1; day <= daysInMonth; day++) {
      (function(dayNumber) {
        var date = new Date(self.currentMonth.getFullYear(), self.currentMonth.getMonth(), dayNumber);
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'adg-product-pickup__day';
        button.textContent = String(dayNumber);
        button.disabled = !self.isAvailable(date);
        button.setAttribute('aria-label', formatFrenchDate(date));
        if (self.selectedDate && isoDate(self.selectedDate) === isoDate(date)) button.classList.add('is-selected');
        button.addEventListener('click', function() { self.selectDate(date); });
        self.daysRoot.appendChild(button);
      })(day);
    }
  };

  ProductPickup.prototype.selectDate = function(date) {
    if (!this.isAvailable(date)) return;
    this.selectedDate = localMidnight(date);
    this.refreshElements();
    if (this.dateProperty) {
      this.dateProperty.value = formatFrenchDate(date);
      this.dateProperty.setAttribute('value', this.dateProperty.value);
    }
    if (this.isoProperty) {
      this.isoProperty.value = isoDate(date);
      this.isoProperty.setAttribute('value', this.isoProperty.value);
    }
    if (this.pickupProperty) {
      this.pickupProperty.value = 'Oui';
      this.pickupProperty.setAttribute('value', 'Oui');
    }
    this.selectedTime = '';
    this.setTimeOptions(date);
    if (this.boutique && this.time && this.time.value) this.selectedTime = this.time.value;
    this.status.hidden = true;
    this.render();
    this.updateSelection();
    this.time.focus();
  };

  ProductPickup.prototype.setTimeOptions = function(date) {
    if (this.boutique) {
      var range = boutiqueWindow(date,this.blackouts,this.preparationDelay());
      this.time.innerHTML = '';
      this.time.disabled = !range;
      if (range) {
        var label = pad(Math.floor(range[0]/60))+'h'+pad(range[0]%60)+' à 18h00';
        var option = document.createElement('option'); option.value = label; option.textContent = 'De '+label;
        this.time.appendChild(option);
      }
      return;
    }
    var slots = date.getDay() === 6
      ? [['11h00 à 15h00', 'De 11h00 à 15h00'], ['15h00 à 18h00', 'De 15h00 à 18h00']]
      : [['12h00 à 15h00', 'De 12h00 à 15h00'], ['15h00 à 18h00', 'De 15h00 à 18h00']];

    this.time.innerHTML = '<option value="">Choisissez un créneau</option>';
    slots.forEach(function(slot) {
      var option = document.createElement('option');
      option.value = slot[0];
      option.textContent = slot[1];
      this.time.appendChild(option);
    }, this);
    this.time.value = '';
    this.selectedTime = '';
    this.time.disabled = false;
  };

  ProductPickup.prototype.updateSelection = function() {
    this.refreshElements();
    var valid = !!(this.settingsReady && this.selectedDate && this.time && this.time.value && this.syncProperties());
    this.root.setAttribute('data-valid', valid ? 'true' : 'false');

    if (valid) {
      var selectedLabel = this.time.options[this.time.selectedIndex].text;
      this.selection.textContent = 'Retrait : ' + formatFrenchDate(this.selectedDate) + ', ' + selectedLabel;
      this.selection.hidden = false;
    } else {
      this.selection.textContent = '';
      this.selection.hidden = true;
    }
    this.updateSubmit();
  };

  ProductPickup.prototype.updateSubmit = function() {
    this.refreshElements();
    if (!this.submit) return;
    var productAvailable = this.root.getAttribute('data-product-available') === 'true';
    var valid = this.root.getAttribute('data-valid') === 'true' && this.syncProperties();
    this.submit.disabled = this.boutiqueNoPickup || !(productAvailable && valid);
  };

  ProductPickup.prototype.setBoutiqueUnavailable = function() {
    this.boutiqueNoPickup = true;
    this.root.setAttribute('data-boutique-no-pickup', 'true');
    this.boutiqueNoPickup = false;
    this.root.removeAttribute('data-boutique-no-pickup');
    if (this.submit && this.submit.textContent.trim() === 'Indisponible') this.submit.textContent = this.submitLabel;
    this.selectedDate = null;
    this.selectedTime = '';
    this.clearProperties();
    if (this.time) this.time.value = '';
    this.time.disabled = true;
    this.calendar.hidden = true;
    this.selection.hidden = true;
    this.root.setAttribute('data-valid', 'false');
    this.status.textContent = 'Indisponible pour le moment. Les disponibilités seront mises à jour à la prochaine ouverture.';
    this.status.className = 'adg-product-pickup__status is-error';
    this.status.hidden = false;
    if (this.submit) {
      this.submit.disabled = true;
      this.submit.textContent = 'Indisponible';
    }
  };

  ProductPickup.prototype.showError = function(message) {
    this.status.textContent = message;
    this.status.className = 'adg-product-pickup__status is-error';
    this.status.hidden = false;
  };

  ProductPickup.prototype.reset = function() {
    var self = this;
    this.selectedDate = null;
    this.selectedTime = '';
    this.clearProperties();
    if (this.time) {
      this.time.value = '';
      this.time.disabled = true;
    }
    this.selection.hidden = true;
    this.root.setAttribute('data-valid', 'false');
    this.currentMonth = firstOfMonth(this.minimumDate());
    this.calendar.hidden = true;
    this.status.textContent = 'Chargement des disponibilités…';
    this.status.className = 'adg-product-pickup__status';
    this.status.hidden = false;
    this.settingsReady = false;
    this.settingsFailed = false;
    this.updateSubmit();
    if (this.boutique && !this.firstAvailableDate()) this.setBoutiqueUnavailable();

    loadCrSettings().then(function(settings) {
      if (self.useSettingsLeadDays) {
        var settingsLeadDays = parseInt(settings && settings.min_days, 10);
        if (!isNaN(settingsLeadDays)) self.leadDays = Math.max(0, settingsLeadDays);
        self.updateHelp();
        self.currentMonth = firstOfMonth(self.minimumDate());
      }
      self.blackouts = blackoutMap(settings);
      self.currentMonth = firstOfMonth(self.minimumDate());
      self.settingsReady = true;
      var firstAvailable = self.firstAvailableDate();
      self.publishFirstAvailableDate();
      if (self.boutique && !firstAvailable) {
        self.setBoutiqueUnavailable();
        return;
      }
      self.status.hidden = true;
      self.calendar.hidden = false;
      self.render();
      self.updateSelection();
    }).catch(function() {
      self.settingsFailed = true;
      self.showError('Impossible de charger les dates disponibles. Fermez cette fenêtre puis réessayez.');
      self.updateSubmit();
    });
  };

  ProductPickup.prototype.isValid = function(showMessage) {
    this.refreshElements();
    if (this.boutique && this.selectedDate) {
      if (!this.isAvailable(this.selectedDate)) {
        this.selectedDate = null; this.selectedTime = ''; this.clearProperties(); if (this.time) this.time.value = '';
      } else this.setTimeOptions(this.selectedDate);
      this.updateSelection();
    }
    if ((this.bentoWeekly || this.smallBatchWeekly || this.creamWeekly) && this.selectedDate && !this.isAvailable(this.selectedDate)) {
      this.selectedDate = null;
      this.selectedTime = '';
      this.clearProperties();
      if (this.time) this.time.value = '';
      this.time.disabled = true;
      this.render();
      this.publishFirstAvailableDate();
      this.updateSelection();
    }
    var valid = this.root.getAttribute('data-valid') === 'true' && this.syncProperties();
    if (!valid && showMessage) {
      if (this.settingsFailed) this.showError('Impossible de charger les dates disponibles. Fermez cette fenêtre puis réessayez.');
      else this.showError('Choisissez une date et un créneau de retrait avant d’ajouter ce produit au panier.');
      this.root.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    return valid;
  };

  function init(root) {
    if (!root || root._adgProductPickup) return root && root._adgProductPickup;
    root._adgProductPickup = new ProductPickup(root);
    return root._adgProductPickup;
  }

  function mount(form, options) {
    if (!form) return null;
    var existing = form.querySelector('[data-adg-product-pickup]');
    if (existing) return init(existing);

    options = options || {};
    var submit = form.querySelector('[type="submit"]');
    if (!submit) return null;

    var root = document.createElement('div');
    root.className = 'adg-product-pickup';
    root.setAttribute('data-adg-product-pickup', '');
    root.setAttribute('data-lead-days', options.leadDays == null ? 'settings' : String(options.leadDays));
    root.setAttribute('data-max-months', String(options.maxMonths || 12));
    root.setAttribute('data-product-available', options.productAvailable === false ? 'false' : 'true');
    root.setAttribute('data-valid', 'false');
    root.innerHTML =
      '<span class="adg-product-pickup__title">Date et créneau de retrait *</span>' +
      '<p class="adg-product-pickup__help">Après 18h, le délai commence le lendemain. Les dimanches, lundis et dates indisponibles sont bloqués.</p>' +
      '<div class="adg-product-pickup__location">' +
        '<strong>Retrait à L’Atelier des Gâteaux</strong>' +
        '<a href="https://www.google.com/maps/search/?api=1&amp;query=23+rue+de+l%27Abb%C3%A9+Gr%C3%A9goire+75006+Paris" target="_blank" rel="noopener">23 rue de l’Abbé Grégoire, 75006 Paris</a>' +
        '<span>Du mardi au vendredi : 12h–18h · Samedi : 11h–18h</span>' +
        '<span>Fermé le dimanche et le lundi</span>' +
        '<a href="mailto:contact@atelierdesgateaux.fr">contact@atelierdesgateaux.fr</a>' +
      '</div>' +
      '<div class="adg-product-pickup__status" data-adg-pickup-status role="status">Chargement des disponibilités…</div>' +
      '<div class="adg-product-pickup__calendar" data-adg-pickup-calendar hidden>' +
        '<div class="adg-product-pickup__month-nav">' +
          '<button type="button" class="adg-product-pickup__nav" data-adg-pickup-prev aria-label="Mois précédent">‹</button>' +
          '<p class="adg-product-pickup__month-label" data-adg-pickup-month></p>' +
          '<button type="button" class="adg-product-pickup__nav" data-adg-pickup-next aria-label="Mois suivant">›</button>' +
        '</div>' +
        '<div class="adg-product-pickup__weekdays" data-adg-pickup-weekdays aria-hidden="true"></div>' +
        '<div class="adg-product-pickup__days" data-adg-pickup-days></div>' +
      '</div>' +
      '<div class="adg-product-pickup__time-wrap">' +
        '<label>Créneau de retrait</label>' +
        '<select class="adg-product-pickup__time" name="properties[Créneau de retrait]" data-adg-pickup-time required disabled>' +
          '<option value="">Choisissez d’abord une date</option>' +
        '</select>' +
      '</div>' +
      '<input type="hidden" name="properties[Date de retrait]" value="" data-adg-pickup-date-property>' +
      '<input type="hidden" name="properties[_Date de retrait ISO]" value="" data-adg-pickup-iso-property>' +
      '<input type="hidden" name="properties[_Retrait par produit]" value="Oui">' +
      '<p class="adg-product-pickup__selection" data-adg-pickup-selection hidden></p>' +
      '<p class="adg-product-pickup__policy"><strong>Conditions de commande :</strong> nos gâteaux sont confectionnés spécialement pour votre commande. Ils ne sont ni annulables ni remboursables. Une demande de report peut être effectuée au minimum 5 jours ouvrés avant la date de retrait, sous réserve de disponibilité.</p>';

    if (options.leadDays === 'boutique') {
      root.querySelector('.adg-product-pickup__policy').textContent = 'Votre produit est réservé après paiement. Merci de respecter le jour de retrait choisi.';
      root.querySelector('.adg-product-pickup__location a[href^="mailto:"]').outerHTML = '<a href="/pages/contact">Nous contacter</a>';
    }
    if (options.leadDays === 'boutique' && !form.querySelector('[data-adg-boutique-conditions]')) {
      var conditions = document.createElement('p');
      conditions.setAttribute('data-adg-boutique-conditions', '');
      conditions.style.cssText = 'display:block;clear:both;width:100%;margin:12px 0 0;font-size:12px;line-height:1.6;color:#8a7268;';
      conditions.textContent = 'Toute commande est non remboursable. Une commande non récupérée à la date de retrait choisie ne pourra pas être reportée.';
      submit.insertAdjacentElement('afterend', conditions);
    }
    form.insertBefore(root, submit);
    submit.disabled = true;
    return init(root);
  }

  function initAll() {
    document.querySelectorAll('[data-adg-product-pickup]').forEach(init);
  }

  function bindFirstAvailable(container, target) {
    var root = container && container.matches && container.matches('[data-adg-product-pickup]')
      ? container
      : container && container.querySelector('[data-adg-product-pickup]');
    if (!root || !target) return false;

    function update(event) {
      var label = event && event.detail && event.detail.label;
      if (!label) label = root.getAttribute('data-first-available-label');
      if (label) target.textContent = label;
    }

    root.addEventListener('adg:pickup-first-available', update);
    update();
    return true;
  }


  function updateCollectionDates() {
    var targets = document.querySelectorAll('[data-adg-collection-date]');
    if (!targets.length) return;
    loadCrSettings().then(function(settings) {
      targets.forEach(function(target) {
        var rule = target.getAttribute('data-adg-collection-date');
        var calendar = Object.create(ProductPickup.prototype);
        calendar.creamWeekly = rule === 'cream-weekly';
        calendar.smallBatchWeekly = rule === 'small-batch-weekly';
        calendar.bentoWeekly = rule === 'bento-weekly';
        calendar.leadDays = Math.max(0, parseInt(rule, 10) || 0);
        calendar.maxMonths = 12;
        calendar.blackouts = blackoutMap(settings);
        var date = calendar.firstAvailableDate();
        target.textContent = date ? formatFrenchDate(date) : 'À confirmer — contactez-nous';
      });
    }).catch(function() {
      targets.forEach(function(target) {
        target.textContent = 'Disponibilités à confirmer — contactez-nous';
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateCollectionDates);
  else updateCollectionDates();
  document.addEventListener('shopify:section:load', updateCollectionDates);
  document.addEventListener('visibilitychange', function() {
    if (!document.hidden) updateCollectionDates();
  });
  setInterval(function() {
    if (!document.hidden) updateCollectionDates();
  }, 60000);


  function updateBoutiqueCards() {
    var cards = document.querySelectorAll('[data-adg-boutique-stock]');
    if (!cards.length) return;
    function display(available) {
      cards.forEach(function(card) {
        card.textContent = available && card.getAttribute('data-adg-boutique-stock') === 'true'
          ? 'Choisir mon retrait →' : 'Indisponible';
      });
    }
    loadCrSettings().then(function(settings) {
      var calendar = Object.create(ProductPickup.prototype);
      calendar.boutique = true;
      calendar.blackouts = blackoutMap(settings);
      display(!!calendar.firstAvailableDate());
    }).catch(function() { display(false); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateBoutiqueCards);
  else updateBoutiqueCards();
  document.addEventListener('shopify:section:load', updateBoutiqueCards);
  document.addEventListener('visibilitychange', function() {
    if (!document.hidden) updateBoutiqueCards();
  });
  setInterval(function() { if (!document.hidden) updateBoutiqueCards(); }, 60000);

  window.ADGProductPickup = {
    boutiqueWindow: boutiqueWindow,
    creamMinimumDate: creamMinimumDate,
    smallBatchMinimumDate: smallBatchMinimumDate,
    bentoMinimumDate: bentoMinimumDate,
    init: init,
    mount: mount,
    bindFirstAvailable: bindFirstAvailable,
    reset: function(root) {
      var instance = init(root);
      if (instance) instance.reset();
    },
    isValid: function(root, showMessage) {
      var instance = init(root);
      return !!(instance && instance.isValid(showMessage));
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();
